/**
 * GelatoMaps — Legacy Shim (UNIDIRECTIONAL)
 *
 * Direction: store → window globals (for legacy modules to READ)
 * Legacy modules must NOT write to store via globals.
 *
 * Hydration: ONE TIME at boot, globals → store.
 * After that, store is the source of truth.
 * @module legacy-shim
 */

import { store } from './store.js'

// ── Store → globals (live sync for legacy readers) ──
store.on('shops', (v) => { window.ALL = v })
store.on('markers', (v) => { window.MKS = v })
store.on('filters', (v) => {
  if (window.F) Object.assign(window.F, v)
})
store.on('premium', (v) => { window.PREMIUM = v })
store.on('featureFlags', (v) => { window.FF = v })
store.on('auth', (v) => {
  window.AUTH_TOKEN = v.token || ''
  window.USER_TOKEN = v.token || ''
  window.CURRENT_USER = v.user
})
store.on('selectedShopIdx', (v) => {
  window._currentPanelShopIdx = v
})

/**
 * ONE-TIME hydration: read legacy globals into store.
 * Call this ONCE after legacy scripts have loaded data.
 */
export function hydrateFromLegacy() {
  if (window.ALL?.length) store.set('shops', window.ALL)
  if (window.MKS?.length) store.set('markers', window.MKS)
  if (window.PREMIUM && Object.keys(window.PREMIUM).length) store.set('premium', window.PREMIUM)
  if (window.FF) store.set('featureFlags', window.FF)

  store.set('auth', {
    token: window.AUTH_TOKEN || window.USER_TOKEN || null,
    user: window.CURRENT_USER || null,
    isAdmin: !!window.AUTH_TOKEN,
  })

  if (window.F) {
    store.set('filters', { ...window.F })
  }

  console.log('[shim] Hydrated store from legacy globals',
    { shops: store.get('shops')?.length || 0, premium: Object.keys(store.get('premium') || {}).length })
}
